export function MediamarktPrivacyFR() {
  return (
    <article>
      <h1>Politique de confidentialité (vie privée)</h1>
      <time dateTime="2024-09-01">Septembre 2024</time>

      <div>
        <p>
          Cette Politique de confidentialité s'applique à tous les produits,
          services et sites Web proposés par Jottacloud. Les références à 'nous'
          et 'notre' font référence à Jottacloud, tandis que "vous" et "votre"
          font référence au client ou à l'utilisateur de Jottacloud.
        </p>

        <h3>Les informations que nous collectons</h3>
        <p>
          Lorsque vous visitez les services et les sites Web de Jottacloud, vous
          nous fournissez deux types d'informations : les Données à caractère
          personnel que vous choisissez sciemment de divulguer et que nous
          collectons, et les informations que nous collectons sur le Site Web
          lorsque vous interagissez avec nos services.
        </p>
        <h3>Les informations que vous fournissez</h3>
        <p>
          Lorsque vous vous inscrivez sur Jottacloud, vous nous communiquez
          votre nom, votre adresse e-mail et votre numéro de téléphone ci-après
          dénommés Données à caractère personnel.
        </p>
        <p>
          Les mots de passe sont cryptés dans nos bases de données. Nous ne
          pouvons pas lire votre mot de passe. Jottacloud n'a pas accès aux
          informations de votre carte de crédit.
        </p>
        <p>
          Si vous êtes un utilisateur enregistré de Jottacloud, vous
          reconnaissez et acceptez que Jottacloud puisse occasionnellement vous
          envoyer par e-mail ou SMS des communications importantes concernant
          votre compte ou le Service.
        </p>
        <h3>Informations sur l'utilisation du site Web</h3>
        <p>
          Lorsque vous accédez à Jottacloud, nous enregistrons votre type de
          navigateur et votre adresse IP. Ces informations sont collectées pour
          tous les visiteurs et utilisateurs de Jottacloud. En outre, nous
          enregistrons certaines informations de votre navigateur à l'aide de
          "cookies". Un cookie est un élément de donnée stocké sur l'ordinateur
          de l'utilisateur et lié à des informations concernant l'utilisateur.
          Nous utilisons des cookies d'identification de session pour confirmer
          que les utilisateurs enregistrés sont connectés.
        </p>
        <p>
          Nous utilisons des cookies permanents pour sauvegarder les
          informations relatives à l'utilisation du site Web. Les cookies
          permanents sont sauvegardés sur votre ordinateur pendant une période
          plus longue. Ces informations ne sont pas personnellement
          identifiables.
        </p>
        <h3>Téléchargement des données</h3>
        <p>
          Lorsque vous téléchargez des fichiers sur Jottacloud, vous envoyez
          également des informations sur le système de fichiers, notamment le
          nom des fichiers et des répertoires. Les fichiers sont cryptés avec
          Secure Socket Layer (SSL) pendant le transfert.
        </p>
        <h3>Comment nous utilisons les informations</h3>
        <ul>
          <li>
            Nous utilisons les informations que nous collectons dans le but de
            fournir aux utilisateurs des services de haute qualité, et de
            développer de nouveaux produits et services pour nos clients et
            clients potentiels.
          </li>
          <li>
            Nous pouvons afficher les métadonnées de votre système de fichiers
            (nom de fichier, tailles, etc. mais pas le contenu de votre fichier)
            pour fournir un support technique.
          </li>
          <li>
            Nous ne vendrons ni ne commercialiserons votre adresse électronique.
          </li>
          <li>
            Nous ne divulguerons pas vos données personnelles à des tiers.
          </li>
          <li>
            Nous ne visualiserons pas les fichiers que vous téléchargez sur
            Jottacloud.
          </li>
        </ul>
        <h3>Enfants de moins de 13 ans</h3>
        <p>
          Les enfants de moins de 13 ans ne sont pas autorisés à s'inscrire sur
          Jottacloud. Jottacloud ne collecte ni ne sollicite sciemment des
          données à caractère personnel auprès de toute personne âgée de moins
          de 13 ans, ni ne permet sciemment à de telles personnes de s'inscrire.
        </p>
        <p>
          Sécurité Nous utilisons des mesures de sécurité conformes aux normes
          de l'industrie pour nous protéger contre la perte, le mauvais usage et
          l'altération des informations sous notre contrôle.
        </p>
        <p>
          Parce que les e-mails et la messagerie instantanée ne sont pas
          reconnus comme des communications sécurisées, nous vous demandons de
          ne pas nous envoyer de données personnelles sensibles par e-mail ou
          par messagerie instantanée.
        </p>
        <p>
          Si vous annulez votre compte, vos données et autres informations
          peuvent être conservées dans nos archives ou nos dossiers de
          sauvegarde jusqu'à leur suppression après 90 jours.
        </p>
        <h3>Liens</h3>
        <p>
          Jottacloud peut contenir des liens vers d'autres sites Web. Nous ne
          sommes pas responsables des pratiques de confidentialité des autres
          sites Web. La présente Politique de confidentialité (vie privée)
          s'applique uniquement aux informations collectées par Jottacloud.
        </p>
        <h3>
          Accès, modification et suppression des données à caractère personnel
        </h3>
        <p>
          Vous avez le droit d'exiger l'accès, la rectification ou la
          suppression des données à caractère personnel que nous traitons. Vous
          avez également le droit d'exiger un traitement limité, de vous opposer
          au traitement et de revendiquer le droit à la portabilité des données.
          Vous pouvez retirer votre consentement au traitement des données à
          caractère personnel à tout moment.
        </p>
        <h3>Plaintes</h3>
        <p>
          Si vous pensez que notre traitement des données à caractère personnel
          ne correspond pas à ce que nous avons décrit ici ou que nous violons
          les lois sur la protection de la vie privée, vous pouvez faire appel à
          l'Autorité de protection des données (APD) :{' '}
          <a
            href="https://www.datatilsynet.no"
            rel="nofollow noopener noreferrer"
            target="_blank"
          >
            https://www.datatilsynet.no
          </a>
          .
        </p>
        <h3>Modifications à cette Politique</h3>
        <p>
          Jottacloud se réserve le droit, à sa seule discrétion, de réviser,
          amender ou modifier cette politique à tout moment. Toute notification
          de révision, d'amendement ou de modification de cette politique sera
          affichée sur les sites Web de Jottacloud, et l'utilisation continue du
          Service par un Utilisateur signifiera son accord à ces modifications.
          Les notifications des modifications susmentionnées seront envoyées à
          l'utilisateur par e-mail.
        </p>
      </div>
    </article>
  )
}
